import styled from 'styled-components';
import TopArrow from '../../assets/images/dropdowntop_arrow.png';

const DropdownWrapper = styled.div`
	position: relative;
	display: inline-block;

	a {
		text-decoration: none;
	}
	.weightTrackingInfo {
		width: 280px;
		right: -126px;
		&:after {
			content: '';
			width: 16px;
			height: 18px;
			background: url(${TopArrow}) no-repeat;
			position: absolute;
			top: -11px;
			left: 129px;
		}
	}
	.labTestInfo {
		width: 280px;
		right: -200px;
		&:after {
			content: '';
			width: 16px;
			height: 18px;
			background: url(${TopArrow}) no-repeat;
			position: absolute;
			top: -11px;
			left: 55px;
		}
	}
	.glucoseInfo {
		width: 280px;
		right: -55px;
		&:after {
			content: '';
			width: 16px;
			height: 18px;
			background: url(${TopArrow}) no-repeat;
			position: absolute;
			top: -11px;
			left: 200px;
		}
	}
`;

export default DropdownWrapper;
